var $c92899672a3fe72e$exports = {};
$c92899672a3fe72e$exports = {
    "dismiss": `Ner\u{101}d\u{12B}t`
};


export {$c92899672a3fe72e$exports as default};
//# sourceMappingURL=lv-LV.mjs.map
